export function TextBlock({ children }) {
  return <div className="text-block">{children}</div>;
}

export function TextSection({ title, children }) {
  return (
    <section className="text-section">
      {title && <h3 className="text-section-title">{title}</h3>}
      <div className="text-section-content">{children}</div>
    </section>
  );
}

export function TextParagraph({ children }) {
  return <p className="text-paragraph">{children}</p>;
}

export function TextInsert({ children }) {
  return <div className="text-insert">{children}</div>;
}
